var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#D9CEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 31H48.75C51.3625 31 53.5 33.1375 53.5 35.75V64.25C53.5 66.8625 51.3625 69 48.75 69H10.75C8.1375 69 6 66.8625 6 64.25V35.75C6 33.1375 8.1375 31 10.75 31ZM32.2675 50.8077L47.8 41.0939C48.3937 40.7139 48.75 40.0727 48.75 39.3839C48.75 37.7927 47.0163 36.8427 45.6625 37.6739L29.75 47.6252L13.8375 37.6739C12.4837 36.8427 10.75 37.7927 10.75 39.3839C10.75 40.0727 11.1062 40.7139 11.7 41.0939L27.2325 50.8077C28.7763 51.7814 30.7238 51.7814 32.2675 50.8077Z",
    fill: "#241D3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.625 57.125H65.375C66.6812 57.125 67.75 58.1938 67.75 59.5C67.75 60.8063 66.6812 61.875 65.375 61.875H60.625C59.3188 61.875 58.25 60.8063 58.25 59.5C58.25 58.1938 59.3188 57.125 60.625 57.125Z",
    fill: "#241D3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.625 38.125H72.5C73.8062 38.125 74.875 39.1938 74.875 40.5C74.875 41.8063 73.8062 42.875 72.5 42.875H60.625C59.3188 42.875 58.25 41.8063 58.25 40.5C58.25 39.1938 59.3188 38.125 60.625 38.125Z",
    fill: "#241D3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.625 47.625H70.125C71.4312 47.625 72.5 48.6938 72.5 50C72.5 51.3063 71.4312 52.375 70.125 52.375H60.625C59.3188 52.375 58.25 51.3063 58.25 50C58.25 48.6938 59.3188 47.625 60.625 47.625Z",
    fill: "#241D3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.4105774a.svg";
export { ForwardRef as ReactComponent };